import React, {Fragment} from 'react';

import {AlertInfo} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {AddressAlertsProps} from './types';

const {addressErrors, successAlert, errorAlert, alertInfo} =
	translations['pt-br'].privateFlow.profile.changeData;

const warningText = {
	apiError: addressErrors.apiError,
	allFieldsEmpty: addressErrors.allFieldsEmpty,
};

export function AddressAlerts({
	showAlert,
	warningInfo,
	typeMessage,
	withoutAlertInfo,
}: AddressAlertsProps) {
	const message = {
		success: successAlert.address,
		error: errorAlert,
	};

	return (
		<Fragment>
			{showAlert && !warningInfo ? (
				<AlertInfo.Root severity={typeMessage}>
					<AlertInfo.Title sx={{mb: 0}} title={message[typeMessage]} />
				</AlertInfo.Root>
			) : null}
			{!withoutAlertInfo ? (
				<AlertInfo.Root>
					<AlertInfo.Description>{alertInfo}</AlertInfo.Description>
				</AlertInfo.Root>
			) : null}
			{warningInfo ? (
				<AlertInfo.Root severity="warning" sx={{mb: 2}}>
					<AlertInfo.Description>{warningText[warningInfo]}</AlertInfo.Description>
				</AlertInfo.Root>
			) : null}
		</Fragment>
	);
}
